import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Ho4ArticleSidebar from '../components/Ho4ArticleSidebar';
import { HO4_LAST_MODIFIED } from '../data/ho4Articles';

function Ho4WorthItArticlePage() {
  const navigate = useNavigate();
  const articleLinkStyle = { color: '#065F46', fontWeight: 600, textDecoration: 'underline' };

  useEffect(() => {
    const previousTitle = document.title;
    const descriptionMeta = document.querySelector('meta[name="description"]');
    const previousDescription = descriptionMeta?.getAttribute('content') ?? '';
    document.title = 'Is HO-4 Worth It? | GetSkimp';
    if (descriptionMeta) {
      descriptionMeta.setAttribute(
        'content',
        'Learn when HO-4 renters insurance is worth it and how to weigh monthly cost against liability and property protection.'
      );
    }
    return () => {
      document.title = previousTitle;
      if (descriptionMeta) descriptionMeta.setAttribute('content', previousDescription);
    };
  }, []);

  return (
    <div className="container">
      <div style={{ display: 'grid', gridTemplateColumns: '260px 1fr', gap: '2rem' }}>
        <Ho4ArticleSidebar
          activeHref="/knowledge-base/is-ho4-worth-it"
          onNavigate={(href) => navigate(href)}
        />
        <section>
          <div style={{ marginBottom: '1rem' }}>
            <button type="button" className="btn btn-sm btn-outline" onClick={() => navigate('/knowledge-base')} style={{ marginBottom: '1rem' }}>
              Back to self help library
            </button>
            <h2 style={{ marginBottom: '0.5rem' }}>Is HO-4 worth it?</h2>
            <p style={{ marginBottom: 0, color: '#4B5563' }}>
              A practical way to decide if renters insurance is worth the monthly premium.
            </p>
            <p style={{ marginTop: '0.5rem', fontSize: '0.85rem', color: '#6B7280' }}>Last modified: {HO4_LAST_MODIFIED}</p>
          </div>

          <article className="card mb-4">
            <div className="card-body">
              <h3 style={{ marginBottom: '0.75rem' }}>Quick answer</h3>
              <p>
                For many renters, HO-4 is worth it because a relatively low monthly cost can provide meaningful
                protection for personal property and liability exposure.
              </p>
              <h3 style={{ marginBottom: '0.75rem', marginTop: '1.5rem' }}>When HO-4 is usually worth it</h3>
              <ul style={{ paddingLeft: '1.2rem', marginBottom: 0 }}>
                <li style={{ marginBottom: '0.5rem' }}>You need liability coverage for your lease or personal risk.</li>
                <li style={{ marginBottom: '0.5rem' }}>Replacing your belongings out-of-pocket would be difficult.</li>
                <li style={{ marginBottom: '0.5rem' }}>You want coverage for theft and some covered water/fire losses.</li>
                <li>Temporary living expenses after a covered loss would strain your budget.</li>
              </ul>
              <p style={{ marginTop: '1rem', marginBottom: 0 }}>
                To estimate value more accurately, combine{' '}
                <Link to="/knowledge-base/how-much-does-ho4-cost-in-texas" style={articleLinkStyle}>
                  Texas HO-4 pricing
                </Link>{' '}
                with{' '}
                <Link to="/knowledge-base/how-much-liability-do-i-need-for-renters-insurance" style={articleLinkStyle}>
                  liability limit guidance
                </Link>
                .
              </p>
            </div>
          </article>

          <section className="card mb-4" style={{ borderColor: 'var(--color-green)', background: 'linear-gradient(135deg, #ECFDF5 0%, #FFFFFF 100%)', boxShadow: 'var(--shadow-md)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#065F46' }}>Start renters insurance with GetSkimp</h3>
              <p style={{ marginBottom: '1rem' }}>See how affordable coverage can be for your rental setup.</p>
              <button type="button" className="btn btn-primary" onClick={() => navigate('/qualify')} style={{ fontWeight: 700, paddingInline: '1.4rem' }}>Get started now</button>
            </div>
          </section>
          <section className="card" style={{ borderColor: '#FBBF24', background: 'linear-gradient(135deg, #FFFBEB 0%, #FFFFFF 100%)' }}>
            <div className="card-body">
              <h3 style={{ marginBottom: '0.5rem', color: '#92400E' }}>Not sure yet?</h3>
              <p style={{ marginBottom: '1rem' }}>Talk to an agent about your specific risk profile before deciding.</p>
              <button type="button" className="btn btn-outline" onClick={() => navigate('/help')} style={{ borderColor: '#D97706', color: '#92400E', fontWeight: 700 }}>Speak to an agent</button>
            </div>
          </section>
        </section>
      </div>
    </div>
  );
}

export default Ho4WorthItArticlePage;

